import script from "./ToastComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastComponent.vue?vue&type=script&setup=true&lang=js"

import "./ToastComponent.vue?vue&type=style&index=0&id=4c0e08f2&scoped=true&lang=css"

import exportComponent from "C:\\wamp64_old\\www\\configurator_vue_version_3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c0e08f2"]])

export default __exports__